import type { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import config from '../config';
import { LastLocation } from '../types';
import { getTenantFromPath } from '../utils/tenant-utils';
import { useAuthContext } from './AuthContext';

const { urls } = config;

export const RequireAuth = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  const { isAuthenticated } = useAuthContext();

  // Extract a valid tenant from the current URL path
  const urlTenant = getTenantFromPath(location.pathname);

  // Check if user is authenticated
  if (!isAuthenticated) {
    const emailParam = new URLSearchParams(location.search).get('email');
    const emailQuery = emailParam ? `?email=${encodeURIComponent(emailParam)}` : '';
    // Construct the tenant-specific signin URL
    if (!urlTenant) {
      return <Navigate to="/error" replace />;
    }
    const signinUrl = `/${urlTenant}/signin${emailQuery}`;
    return <Navigate to={signinUrl} state={{ from: location }} replace />;
  }

  if (isAuthenticated) {
    // Preserve query string for flows that rely on URL params (for example email prefill).
    sessionStorage.setItem(LastLocation, `${location.pathname}${location.search || ''}`);
  }
  return children;
};
